import React, {Component, useEffect, useRef} from 'react';
import {withFormik, Form, Field} from 'formik';
import * as Yup from 'yup';

import {renderField} from '../../../../utils/form-utils';


export const  ContactForm = ({handleSubmit, isSubmitting, isValid}) => {

    return (
            <Form onSubmit={handleSubmit} noValidate>
                <Field
                    type="text"
                    name="firstname"
                    component={renderField}
                    placeholder="First Name"
                />

                <Field
                    type="text"
                    name="lastname"
                    component={renderField}
                    placeholder="Last Name"
                />
                <Field
                    type="text"
                    name="jobtitle"
                    component={renderField}
                    placeholder="Job Title"
                />
                <Field
                    type="text"
                    name="phone"
                    component={renderField}
                    placeholder="Phone Number"
                />

                <Field
                    type="text"
                    name="company"
                    component={renderField}
                    placeholder="Company Name"
                />

                <Field
                    type="email"
                    name="email"
                    component={renderField}
                    placeholder="Email"
                />

                <Field
                    type="textarea"
                    name="how_did_you_hear_about_us"
                    component={renderField}
                    placeholder="How Did You Hear About Us"
                />

                <Field
                    type="textarea"
                    name="description"
                    component={renderField}
                    placeholder="Description"
                />

                <button
                    type="submit"
                    className="btn btn-outline-primary"
                    disabled={!isValid || isSubmitting}
                >
                    SEND
                </button>
            </Form>
        );

}

export default withFormik({
    mapPropsToValues: () => ({
        firstname: '',
        lastname: '',
        jobtitle: '',
        phone: '',
        company: '',
        email: '',
        // budget: '',
        how_did_you_hear_about_us: '',
        description: '',
    }),
    validationSchema: Yup.object().shape({
        firstname: Yup.string().required('Required'),
        lastname: Yup.string().required('Required'),
        jobtitle: Yup.string().required('Required'),
        phone: Yup.string().required('Required'),
        company: Yup.string().required('Required'),
        email: Yup.string()
            .email('Invalid email')
            .required('Required'),
        how_did_you_hear_about_us: Yup.string(),
        description: Yup.string().required('Required'),
        // webformmetadata: Yup.string()
    }),
    handleSubmit: (values, formikBag) => {
        const {
            setSubmitting,
            props: {onSubmit},
        } = formikBag;
        onSubmit(values, setSubmitting);
    },
})(ContactForm);
